let columns = document.querySelectorAll('.start-banner-column');

for (let column of columns) {
    column.addEventListener('mouseenter', (e) => {
        document.querySelector('.start-banner-grid').dataset.activePosition = e.target.dataset.position;
    })

    column.addEventListener('mouseleave', (e) => {
        document.querySelector('.start-banner-grid').dataset.activePosition = '';
    })
}